// extracted by mini-css-extract-plugin
module.exports = {"background":"Z_dV","shopping__wrapper__examples":"Z_d7","active":"Z_d8","shopping__wrapper__project":"Z_d9"};